module.exports = __webpack_public_path__ + "static/img/finish.3cfbe63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/finish.png
// module id = vzC3
// module chunks = 1